import script from "./method-item.vue?vue&type=script&setup=true&lang=ts"
export * from "./method-item.vue?vue&type=script&setup=true&lang=ts"

import "./method-item.vue?vue&type=style&index=0&id=3a576a28&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a576a28"]])

export default __exports__